export const productionReportsColumns = {
  shippingColumns: [
    { name: 'property_number', title: 'pNum' },
    { name: 'property_name', title: 'SHIPPING' },
    { name: 'salesperson', title: 'Rep' },
    { name: 'csm_name', title: 'CSM' },
    { name: 'completed_by', title: 'Prod' },
    { name: 'tenants_entered', title: 'T' },
    { name: 'project_completed', title: 'P' },
    { name: 'screen_approval', title: 'A' },
    { name: 'deposit_rcvd', title: '$' },
    { name: 'last_sale_date', title: 'SaleDate' },
    { name: 'online_upd_expire', title: 'Expected Ship Date' },
    { name: 'status_notes', title: 'Status/Install' },
    { name: 'pos_0_vendor', title: 'Custom Enclosure' },
    { name: 'due_date', title: 'ShipDate' },
    { name: 'pcsUnits', title: 'Units' },
    { name: 'totalRevenue', title: 'Revenue' }
  ],

  haveContentColumns: [
    { name: 'property_number', title: 'pNum' },
    { name: 'property_name', title: 'HAVE CONTENT' },
    { name: 'client_name', title: 'Client Name' },
    { name: 'salesperson', title: 'Rep' },
    { name: 'csm_name', title: 'CSM' },
    { name: 'completed_by', title: 'Prod' },
    { name: 'tenants_entered', title: 'T' },
    { name: 'project_completed', title: 'P' },
    { name: 'screen_approval', title: 'A' },
    { name: 'deposit_rcvd', title: '$' },
    { name: 'last_sale_date', title: 'SaleDate' },
    { name: 'online_upd_expire', title: 'Expected Ship Date' },
    { name: 'status_notes', title: 'Status/Install' },
    { name: 'pos_0_vendor', title: 'Custom Enclosure' },
    { name: 'pcsUnits', title: 'Units' },
    { name: 'totalRevenue', title: 'Revenue' }
  ],

  needContentColumn: [
    { name: 'property_number', title: 'pNum' },
    { name: 'property_name', title: 'NEED CONTENT' },
    { name: 'client_name', title: 'Client Name' },
    { name: 'salesperson', title: 'Rep' },
    { name: 'csm_name', title: 'CSM' },
    { name: 'completed_by', title: 'Prod' },
    { name: 'ko', title: 'KO' },
    { name: 'deposit_rcvd', title: '$' },
    { name: 'last_sale_date', title: 'SaleDate' },
    { name: 'online_upd_expire', title: 'Expected Ship Date' },
    { name: 'status_notes', title: 'Status/Install' },
    { name: 'pos_0_vendor', title: 'Custom Enclosure' },
    { name: 'pcsUnits', title: 'Units' },
    { name: 'totalRevenue', title: 'Revenue' }
  ],

  onHoldColumn: [
    { name: 'property_number', title: 'pNum' },
    { name: 'property_name', title: 'ON HOLD' },
    { name: 'client_name', title: 'Client Name' },
    { name: 'salesperson', title: 'Rep' },
    { name: 'csm_name', title: 'CSM' },
    { name: 'completed_by', title: 'Prod' },
    { name: 'tenants_entered', title: 'T' },
    { name: 'project_completed', title: 'P' },
    { name: 'screen_approval', title: 'A' },
    { name: 'deposit_rcvd', title: '$' },
    { name: 'last_sale_date', title: 'SaleDate' },
    { name: 'online_upd_expire', title: 'Expected Ship Date' },
    { name: 'status_notes', title: 'Status/Install' },
    { name: 'pos_0_vendor', title: 'Custom Enclosure' },
    { name: 'pcsUnits', title: 'Units' },
    { name: 'totalRevenue', title: 'Revenue' }
  ],

  detailColumns: [
    { name: 'units', title: 'Units' },
    { name: 'installation_type', title: 'Enclosure' },
    { name: 'enclosure_finish', title: 'Finish' },
    { name: 'model', title: 'PC Model' },
    { name: 'orientation', title: 'Resolution/Orientation' },
    { name: 'sale_date', title: 'PC Sale Date' },
    { name: 'sched_ship_date', title: 'Scheduled Ship Date' },
    { name: 'revenue', title: 'Revenue' }
  ],

  warehouseColumns: [
    { name: 'property_number', title: 'pNum' },
    { name: 'property_name', title: 'SHIPPING' },
    { name: 'status_notes', title: 'Status/Install' },
    { name: 'salesperson', title: 'Rep' },
    { name: 'completed_by', title: 'Prod' },
    { name: 'project_completed', title: 'P' },
    { name: 'due_date', title: 'ShipDate' },
    { name: 'pcsUnits', title: 'Units' },
  ],

  tableDetailColumnExtensions: [
    // shipping
    { columnName: 'property_number', width: 100 },
    { columnName: 'property_name', width: 150 },
    { columnName: 'salesperson', width: 100 },
    { columnName: 'csm_name', width: 100 },
    { columnName: 'completed_by', width: 100 },
    { columnName: 'tenants_entered', width: 50 },
    { columnName: 'project_completed', width: 50 },
    { columnName: 'screen_approval', width: 50},
    { columnName: 'deposit_rcvd', width: 50 },
    { columnName: 'last_sale_date', width: 100 },
    { columnName: 'online_upd_expire', width: 170 },
    { columnName: 'status_notes', width: 250 },
    { columnName: 'pos_0_vendor', width: 220 },
    { columnName: 'due_date', width: 100 },
    { columnName: 'pcsUnits', width: 80 },
    { columnName: 'totalRevenue', width: 100 },
    
    // haveContent
    { columnName: 'property_number', width: 100 },
    { columnName: 'property_name', width: 150 },
    { columnName: 'client_name', width: 150 },
    { columnName: 'salesperson', width: 100 },
    { columnName: 'csm_name', width: 100 },
    { columnName: 'completed_by', width: 50 },
    { columnName: 'tenants_entered', width: 50 },
    { columnName: 'project_completed', width: 50 },
    { columnName: 'screen_approval', width: 50 },
    { columnName: 'deposit_rcvd', width: 50 },
    { columnName: 'last_sale_date', width: 100 },
    { columnName: 'online_upd_expire', width: 170 },
    { columnName: 'status_notes', width: 250 },
    { columnName: 'pos_0_vendor', width: 220 },
    { columnName: 'pcsUnits', width: 80 },
    { columnName: 'totalRevenue', width: 100 },

  // needContent
    { columnName: 'property_number', width: 100 },
    { columnName: 'property_name', width: 150 },
    { columnName: 'client_name', width: 150 },
    { columnName: 'salesperson', width: 100 },
    { columnName: 'csm_name', width: 100 },
    { columnName: 'completed_by', width: 50 },
    { columnName: 'ko', width: 50 },
    { columnName: 'deposit_rcvd', width: 50 },
    { columnName: 'last_sale_date', width: 100 },
    { columnName: 'online_upd_expire', width: 170 },
    { columnName: 'status_notes', width: 250 },
    { columnName: 'pos_0_vendor', width: 220 },
    { columnName: 'pcsUnits', width: 80 },
    { columnName: 'totalRevenue', width: 100 },
   
    // onHold
    { columnName: 'property_number', width: 100 },
    { columnName: 'property_name', width: 150 },
    { columnName: 'client_name', width: 150 },
    { columnName: 'salesperson', width: 100 },
    { columnName: 'csm_name', width: 100 },
    { columnName: 'completed_by', width: 50 },
    { columnName: 'tenants_entered', width: 50 },
    { columnName: 'project_completed', width: 50 },
    { columnName: 'screen_approval', width: 50 },
    { columnName: 'deposit_rcvd', width: 50 },
    { columnName: 'last_sale_date', width: 100 },
    { columnName: 'online_upd_expire', width: 170 },
    { columnName: 'status_notes', width: 250 },
    { columnName: 'pos_0_vendor', width: 220 },
    { columnName: 'pcsUnits', width: 80 },
    { columnName: 'totalRevenue', width: 100 },
    { columnName: 'units', width: 100 },
    { columnName: 'enclosure_finish', width: 200 },
    { columnName: 'model', width: 200 },
    { columnName: 'sale_date', width: 150 },
    { columnName: 'ship_date', width: 150 },
    { columnName: 'revenue', width: 150 },

  ],
};


// WEBPACK FOOTER //
// ./src/components/Production/productionReportsColumns.ts